import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-518659d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = { class: "vrt-body" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Thank you for Red Tagging this trailer!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "vrt-subtitle" }, " This information has been sent to the correct team for repairs. ", -1))
const _hoisted_5 = {
  key: 0,
  class: "vrt-caption"
}
const _hoisted_6 = {
  key: 1,
  class: "vrt-prompt"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_VirtualRedTagTrailerGraphic = _resolveComponent("VirtualRedTagTrailerGraphic")!
  const _component_fbx_button = _resolveComponent("fbx-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader, { outlined: "" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_VirtualRedTagTrailerGraphic, {
        class: "vrt-graphic",
        state: _ctx.GraphicState.redTagged
      }, null, 8, ["state"]),
      (_ctx.trailer)
        ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.trailerTypeLabel) + " #" + _toDisplayString(_ctx.trailer.trailerNumber), 1))
        : _createCommentVNode("", true),
      (_ctx.assessmentId)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, " Want notifications on this Red Tag? "))
        : _createCommentVNode("", true),
      (_ctx.assessmentId)
        ? (_openBlock(), _createBlock(_component_fbx_button, {
            key: 2,
            "button-text": "Yes, send me notifications",
            theme: "primaryOutline",
            class: "vrt-notify-button",
            onClick: _ctx.navigateToNotifications
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_fbx_button, {
        "button-text": "Return to Pointe",
        theme: "link",
        class: "italic vrt-return-link",
        onClick: _ctx.navigateToWelcome
      }, null, 8, ["onClick"])
    ])
  ]))
}